const getFilteredIcons = (icons = [], filterValue = '') =>
  icons.filter((item) => item.title.includes(filterValue));

export default getFilteredIcons;
